export const SET_GENESIS_BALANCES = '@genesisBalances/SET_GENESIS_BALANCES' as const;
export const SET_TOTAL = '@genesisBalances/SET_TOTAL' as const;
